module.exports = __webpack_public_path__ + "img/version_img5.eb229ef0.png";